import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ContattiPage = () => {
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    azienda: '',
    email: '',
    telefono: '',
    messaggio: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5gdl3jihlvellpk4oeg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          cognome: '',
          azienda: '',
          email: '',
          telefono: '',
          messaggio: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="pt-32 pb-16 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Contattaci</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
            Siamo a tua disposizione per fornirti tutte le informazioni di cui hai bisogno. Compila il form o contattaci direttamente.
          </p>
        </div>
      </section>
      
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-8">Informazioni di Contatto</h2>
              
              <div className="space-y-8 mb-12">
                <div className="flex items-start">
                  <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Sede Legale</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Via Don Domenico D'Angelo 31<br />
                      80025 Casandrino (NA)<br />
                      Italia
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Telefono</h3>
                    <a href="tel:+393508628049" className="text-gray-600 hover:text-green-600 cursor-pointer text-lg">
                      +39 350 862 8049
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-purple-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Email</h3>
                    <a href="mailto:ordini.amacasrl@gmail.com" className="text-gray-600 hover:text-purple-600 cursor-pointer block mb-1 break-all">
                      ordini.amacasrl@gmail.com
                    </a>
                    <a href="mailto:amacasrl2025@pec.it" className="text-gray-600 hover:text-purple-600 cursor-pointer block break-all">
                      amacasrl2025@pec.it
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                    <i className="ri-time-line text-2xl text-orange-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Orari di Apertura</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Lunedì - Venerdì: 09:00 - 18:00<br />
                      Sabato - Domenica: Chiuso
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-gray-50 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Dati Aziendali</h3>
                <div className="space-y-2 text-gray-700">
                  <p><strong>Ragione Sociale:</strong> Amaca S.r.l.</p>
                  <p><strong>Partita IVA:</strong> 10914011217</p>
                  <p><strong>Sede:</strong> Via Don Domenico D'Angelo 31, 80025 Casandrino (NA)</p>
                </div>
              </div>
            </div>
            
            <div>
              <div className="bg-gray-50 rounded-2xl p-8 lg:p-10">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Richiedi Informazioni</h2>
                <p className="text-gray-600 mb-8">
                  Compila il form per ricevere il listino prezzi riservato o per richiedere informazioni sui nostri prodotti e servizi.
                </p>
                
                <form onSubmit={handleSubmit} data-readdy-form id="contatti-form">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">
                        Nome *
                      </label>
                      <input
                        type="text"
                        id="nome"
                        name="nome"
                        value={formData.nome}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="cognome" className="block text-sm font-medium text-gray-700 mb-2">
                        Cognome *
                      </label>
                      <input
                        type="text"
                        id="cognome"
                        name="cognome"
                        value={formData.cognome}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm"
                      />
                    </div>
                  </div>
                  
                  <div className="mb-6">
                    <label htmlFor="azienda" className="block text-sm font-medium text-gray-700 mb-2">
                      Azienda
                    </label>
                    <input
                      type="text"
                      id="azienda"
                      name="azienda"
                      value={formData.azienda}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm"
                    />
                  </div>
                  
                  <div className="mb-6">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm"
                    />
                  </div>
                  
                  <div className="mb-6">
                    <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-2">
                      Telefono
                    </label>
                    <input
                      type="tel"
                      id="telefono"
                      name="telefono"
                      value={formData.telefono}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent text-sm"
                    />
                  </div>
                  
                  <div className="mb-6">
                    <label htmlFor="messaggio" className="block text-sm font-medium text-gray-700 mb-2">
                      Messaggio *
                    </label>
                    <textarea
                      id="messaggio"
                      name="messaggio"
                      value={formData.messaggio}
                      onChange={handleChange}
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600 focus:border-transparent resize-none text-sm"
                      placeholder="Descrivi la tua richiesta..."
                    ></textarea>
                    <p className="text-xs text-gray-500 mt-1">Massimo 500 caratteri</p>
                  </div>
                  
                  {submitStatus === 'success' && (
                    <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                      <p className="text-green-800 text-sm flex items-center">
                        <i className="ri-check-line mr-2"></i>
                        Messaggio inviato con successo! Ti contatteremo presto.
                      </p>
                    </div>
                  )}
                  
                  {submitStatus === 'error' && (
                    <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                      <p className="text-red-800 text-sm flex items-center">
                        <i className="ri-error-warning-line mr-2"></i>
                        Si è verificato un errore. Riprova più tardi.
                      </p>
                    </div>
                  )}
                  
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-all disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                  >
                    {isSubmitting ? 'Invio in corso...' : 'Invia Richiesta'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Dove Siamo</h2>
          <div className="rounded-2xl overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.456789!2d14.2500!3d40.9333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDU1JzU5LjkiTiAxNMKwMTUnMDAuMCJF!5e0!3m2!1sit!2sit!4v1234567890"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mappa Amaca S.r.l."
            ></iframe>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default ContattiPage;
